import script from "./departmentsBasic.vue?vue&type=script&lang=ts&setup=true"
export * from "./departmentsBasic.vue?vue&type=script&lang=ts&setup=true"

import "./departmentsBasic.vue?vue&type=style&index=0&id=6776e564&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6776e564"]])

export default __exports__